import * as signalR from '@aspnet/signalr'

let retry = 7
let timeoutId = null
let stoppedForTime = false

const start = (connection, hubName) => {
    if (connection.state === signalR.HubConnectionState.Disconnected) {
        connection.start().then(() => {
            console.log(`${hubName} connected`)
            if (timeoutId !== null) {
                window.clearTimeout(timeoutId)
            }
            retry = 7
            stoppedForTime = false

            timeoutId = window.setTimeout(() => {
                retry = 7
                timeoutId = null
                stoppedForTime = true

                connection.stop()
            }, 480 * 60 * 1000)

        }).catch((err) => {
            console.log(`${hubName} failed`)
            console.log(err)
            retry--
            if (retry > 0) {
                setTimeout(() => {
                    start(connection, hubName)
                }, Math.random() * 120000)
            }
        })
    }
}

export default (hubName, channels) => {
    const connection = new signalR.HubConnectionBuilder()
        .withUrl(`${PUSH_API_URL}/${hubName}`)
        .configureLogging(signalR.LogLevel.Information)
        .build()

    channels.forEach(channel => {
        connection.on(channel.name, channel.callback)
    })

    connection.onclose((err) => {
        if (typeof err !== "undefined") {
            console.log(err)
        }
        if(!stoppedForTime)
            start(connection, hubName)
    })

    start(connection, hubName)
}
